import { cn } from '@/lib/utils';

export const CopyIcon = ({ className }: { className?: string }) => {
  return (
    <svg className={cn('size-4', className)} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5153 0H2.78792C2.40244 0.00105563 2.03305 0.154654 1.76048 0.427228C1.48791 0.699803 1.33431 1.06919 1.33325 1.45467V11.6367H2.78792V1.45467H11.5153V0ZM13.6973 2.90933H5.69725C5.31189 2.91039 4.9426 3.06389 4.67005 3.33633C4.39749 3.60876 4.24382 3.97797 4.24259 4.36333V14.5453C4.24364 14.9307 4.39715 15.3 4.66958 15.5725C4.94201 15.8451 5.31122 15.9988 5.69659 16H13.6966C14.0821 15.9989 14.4515 15.8453 14.724 15.5728C14.9966 15.3002 15.1502 14.9308 15.1513 14.5453V4.36333C15.15 3.97797 14.9963 3.60876 14.7238 3.33633C14.4512 3.06389 14.0826 2.91039 13.6973 2.90933ZM13.6973 14.546H5.69725V4.36333H13.6973V14.546Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const InfoIcon = ({ className }: { className?: string }) => {
  return (
    <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={cn('size-6', className)}>
      <g clipPath="url(#clip0_12610_4575)">
        <path
          d="M7.65 4.25H9.35V5.95H7.65V4.25ZM7.65 7.65H9.35V12.75H7.65V7.65ZM8.5 0C6.81886 0 5.17547 0.498516 3.77766 1.43251C2.37984 2.3665 1.29037 3.69402 0.647028 5.24719C0.00368289 6.80036 -0.164645 8.50943 0.163329 10.1583C0.491303 11.8071 1.30085 13.3217 2.4896 14.5104C3.67834 15.6992 5.1929 16.5087 6.84173 16.8367C8.49057 17.1646 10.1996 16.9963 11.7528 16.353C13.306 15.7096 14.6335 14.6202 15.5675 13.2223C16.5015 11.8245 17 10.1811 17 8.5C17 6.24566 16.1045 4.08365 14.5104 2.48959C12.9164 0.895533 10.7543 0 8.5 0ZM8.5 15.3C7.15509 15.3 5.84038 14.9012 4.72213 14.154C3.60387 13.4068 2.7323 12.3448 2.21762 11.1022C1.70295 9.85971 1.56828 8.49245 1.83066 7.17338C2.09304 5.85431 2.74068 4.64267 3.69168 3.69167C4.64267 2.74068 5.85432 2.09304 7.17339 1.83066C8.49246 1.56828 9.85971 1.70294 11.1022 2.21762C12.3448 2.73229 13.4068 3.60387 14.154 4.72212C14.9012 5.84038 15.3 7.15509 15.3 8.5C15.2978 10.3028 14.5806 12.0311 13.3058 13.3058C12.0311 14.5806 10.3028 15.2977 8.5 15.3Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_12610_4575">
          <rect width="17" height="17" fill="none" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SpinnerIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-6 text-[#0039A4] h-10 w-10', className)}
    >
      <g id="spinner">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0417 9.91667C18.7801 9.91667 21 7.69675 21 4.95833C21 2.21992 18.7801 0 16.0417 0C13.3033 0 11.0833 2.21992 11.0833 4.95833C11.0833 7.69675 13.3033 9.91667 16.0417 9.91667ZM36.75 7.58333C36.75 11.1272 33.8772 14 30.3333 14C26.7895 14 23.9167 11.1272 23.9167 7.58333C23.9167 4.03951 26.7895 1.16667 30.3333 1.16667C33.8772 1.16667 36.75 4.03951 36.75 7.58333ZM42 23.625C42 27.6521 38.7354 30.9167 34.7083 30.9167C30.6813 30.9167 27.4167 27.6521 27.4167 23.625C27.4167 19.5979 30.6813 16.3333 34.7083 16.3333C38.7354 16.3333 42 19.5979 42 23.625ZM8.75 14C8.75 16.2552 6.92183 18.0833 4.66667 18.0833C2.4115 18.0833 0.583333 16.2552 0.583333 14C0.583333 11.7448 2.4115 9.91667 4.66667 9.91667C6.92183 9.91667 8.75 11.7448 8.75 14ZM3.79167 30.9167C5.88575 30.9167 7.58333 29.2191 7.58333 27.125C7.58333 25.0309 5.88575 23.3333 3.79167 23.3333C1.69759 23.3333 0 25.0309 0 27.125C0 29.2191 1.69759 30.9167 3.79167 30.9167ZM15.75 36.75C15.75 38.683 14.183 40.25 12.25 40.25C10.317 40.25 8.75 38.683 8.75 36.75C8.75 34.817 10.317 33.25 12.25 33.25C14.183 33.25 15.75 34.817 15.75 36.75ZM25.9583 42C27.7302 42 29.1667 40.5636 29.1667 38.7917C29.1667 37.0198 27.7302 35.5833 25.9583 35.5833C24.1864 35.5833 22.75 37.0198 22.75 38.7917C22.75 40.5636 24.1864 42 25.9583 42Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const HeadsetMicIcon = ({ className }: { className?: string }) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={cn('size-4', className)}>
      <g>
        <path
          d="M7.8545 0C6.19573 0 4.6049 0.658944 3.43197 1.83187C2.25905 3.0048 1.6001 4.59563 1.6001 6.2544V11.12C1.59947 11.394 1.65296 11.6653 1.75751 11.9186C1.86206 12.1718 2.0156 12.4019 2.20932 12.5956C2.40303 12.7893 2.63311 12.9428 2.88634 13.0474C3.13956 13.1519 3.41095 13.2054 3.6849 13.2048H5.7697V7.6448H2.9897V6.2544C2.9897 4.96417 3.50224 3.72679 4.41457 2.81447C5.3269 1.90214 6.56428 1.3896 7.8545 1.3896C9.14473 1.3896 10.3821 1.90214 11.2944 2.81447C12.2068 3.72679 12.7193 4.96417 12.7193 6.2544V7.644H9.9393V13.2032H12.7201V13.8984H7.8545V15.288H12.0241C12.2981 15.2886 12.5694 15.2351 12.8227 15.1306C13.0759 15.026 13.306 14.8725 13.4997 14.6788C13.6934 14.4851 13.847 14.255 13.9515 14.0018C14.056 13.7485 14.1095 13.4772 14.1089 13.2032V6.2544C14.1089 4.59563 13.45 3.0048 12.277 1.83187C11.1041 0.658944 9.51327 0 7.8545 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const CheckIcon = ({ className }: { className?: string }) => {
  return (
    <svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" className={cn('size-4', className)}>
      <g>
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2164 2.86666C11.4279 3.07819 11.4279 3.42116 11.2164 3.63269L5.25802 9.59102C5.04648 9.80256 4.70352 9.80256 4.49198 9.59102L1.78365 6.88269C1.57212 6.67116 1.57212 6.32819 1.78365 6.11666C1.99518 5.90512 2.33815 5.90512 2.54968 6.11666L4.875 8.44198L10.4503 2.86666C10.6619 2.65512 11.0048 2.65512 11.2164 2.86666Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const ErrorIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={cn('size-4', className)}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
  );
};

export const QrScanIcon = ({ className }: { className?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={cn('size-4', className)} viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_12614_8639)">
        <path
          d="M6 3.6V6H3.6V3.6H6ZM7.2 2.4H2.4V7.2H7.2V2.4ZM6 10V12.4H3.6V10H6ZM7.2 8.8H2.4V13.6H7.2V8.8ZM12.4 3.6V6H10V3.6H12.4ZM13.6 2.4H8.8V7.2H13.6V2.4ZM8.8 8.8H10V10H8.8V8.8ZM10 10H11.2V11.2H10V10ZM11.2 8.8H12.4V10H11.2V8.8ZM8.8 11.2H10V12.4H8.8V11.2ZM10 12.4H11.2V13.6H10V12.4ZM11.2 11.2H12.4V12.4H11.2V11.2ZM12.4 10H13.6V11.2H12.4V10ZM12.4 12.4H13.6V13.6H12.4V12.4ZM16 4H14.4V1.6H12V0H16V4ZM16 16V12H14.4V14.4H12V16H16ZM0 16H4V14.4H1.6V12H0V16ZM0 0V4H1.6V1.6H4V0H0Z"
          fill="#04091D"
        />
      </g>
      <defs>
        <clipPath id="clip0_12614_8639">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlusIcon = ({ className }: { className?: string }) => {
  return (
    <svg className={cn('size-7', className)} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.333 25.6668V15.6668H2.33301V12.3335H12.333V2.3335H15.6663V12.3335H25.6663V15.6668H15.6663V25.6668H12.333Z"
        fill="#5B78A1"
      />
    </svg>
  );
};
